import { gql } from '@apollo/client';
import { PLAYER_INFO_FRAGMENT, PLAYER_STATS_FRAGMENT } from '../../fragments';

export const GET_STATS = gql`
  ${PLAYER_STATS_FRAGMENT}
  ${PLAYER_INFO_FRAGMENT}
  query GetStats($seasonId: Int) {
    careerStats(where: { seasonBySeason: { id: { _eq: $seasonId } } }) {
      ...PlayerStats
      playerByPlayer {
        ...PlayerInfo
      }
      seasonBySeason {
        year
        season
      }
      teamByTeam {
        abbreviation
        color
        colorSecondary
        champion
        id
        name
      }
    }
  }
`;
